export const LIST_TRANSACTION_INITIATED = "LIST_TRANSACTION_INITIATED";
export const LIST_TRANSACTION_SUCCESS = "LIST_TRANSACTION_SUCCESS";
export const LIST_TRANSACTION_FAILED = "LIST_TRANSACTION_FAILED";